import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';


interface ConfirmDialogProps {
  title: string;
  text: string;
  buttons: {
    text: string;
    onClick: () => any;
  }[];
  resolve: ((value: boolean) => void) | null;
}

const ConfirmDialog = ({ title, text, buttons, resolve }: ConfirmDialogProps) => {
  return (
    <Dialog
      open={true}
      onClose={() => void 0}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent style={{ padding: "24px" }}>
        <DialogContentText id="alert-dialog-description">
          {text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {buttons.map((button, index) => (
          <Button
            variant="outlined"
            key={index}
            onClick={() => {
              resolve?.(button.onClick())
            }}
            data-test-id={`confirm-dialog-button-${button.text.toLowerCase().replace(/\s+/g, '-')}`}
          >
            {button.text}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
